import { FC, PropsWithChildren } from 'react';
import { ShopInternalDisabledFeatureAlert } from 'containers/shop';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { ROUTES } from 'config';
import { useRouteMatch } from 'react-router-dom';

export const ShopInternalLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <ShopInternalDisabledFeatureAlert />

      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('shop.internal.title'),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'items',
                label: t('menu.items'),
                url: ROUTES.shop.internal.items.list,
                isActive: path === ROUTES.shop.internal.items.list,
              },
              {
                key: 'inventory',
                label: t('shop.inventory.title'),
                url: ROUTES.shop.internal.inventory.list,
                isActive: path === ROUTES.shop.internal.inventory.list,
              },
              {
                key: 'settings',
                label: t('common.settings'),
                url: ROUTES.shop.internal.settings,
                isActive: path === ROUTES.shop.internal.settings,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
